<template>
    <div
        v-if="showLoader"
        class="fixed left-0 top-0 w-screen h-screen z-[99998] flex items-center justify-center"
        style="background: rgba(255, 255, 255, 0.5); backdrop-filter: blur(2px)"
    >
        <div class="flex justify-content-center">
            <div class="loading">
                <div class="effect-1 effects" />
                <div class="effect-2 effects" />
                <div class="effect-3 effects" />
            </div>
        </div>
        <span class="loader" />
    </div>
</template>

<script setup lang="ts">
    import { ref, type Ref, watch } from 'vue'

    import { useAppStore } from '@/stores/app.ts'

    // data
    const appStore = useAppStore()

    const showLoader: Ref<boolean> = ref(false)
    let loaderTimeout = 0

    // watcher
    watch(() => appStore.isLoaderActive(), (value) => {
        if (!value) {
            showLoader.value = false
            clearTimeout(loaderTimeout)
            return
        }

        if (!showLoader.value) {
            loaderTimeout = setTimeout(() => {
                showLoader.value = true
            }, 1000)
        }
    }, { immediate: true })
</script>

<style scoped>
.loading {
  position: absolute;
  left: calc(50% - 35px);
  top: 50%;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 3px solid transparent;
}
.loading .effect-1,
.loading .effect-2 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid var(--color-primary-400);
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading .effect-1 {
  animation: rotate 1s ease infinite;
}
.loading .effect-2 {
  animation: rotateOpacity 1s ease infinite 0.1s;
}
.loading .effect-3 {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-left: 3px solid var(--color-primary-400);
  -webkit-animation: rotateOpacity 1s ease infinite 0.2s;
  animation: rotateOpacity 1s ease infinite 0.2s;
  border-radius: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.loading .effects {
  transition: all 0.3s ease;
}

@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
@keyframes rotateOpacity {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    opacity: 0.1;
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
    opacity: 1;
  }
}
</style>
